import { memo } from 'react';
import { ActivePanelGate } from 'src/entity/ActivePanel';
import { UserGate } from 'src/entity/User';
import { PostSecondStageVotesGate } from 'src/features/postSecondStageVotes';
import { PostVotesGate } from 'src/features/postVotes';
import { SavePostCardGate } from 'src/features/savePostCard';
import { SetImageStatusGate } from 'src/features/setImageStatus';

export const GateProvider = memo(() => (
  <>
    <PostVotesGate />
    <UserGate />
    <PostSecondStageVotesGate />
    <ActivePanelGate />
    <SavePostCardGate />
    <SetImageStatusGate />
  </>
));
